interface Props {
  mobile: boolean;
}

const SvgOrderSummary: React.FC<Props> = ({ mobile }) => {
  return (
    <svg
      style={{ transform: mobile ? "" : "scale(1.13)" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9732_41839)">
        <path
          d="M7.99998 1.33301C4.324 1.33301 1.33331 4.3237 1.33331 7.99967C1.33331 11.6757 4.324 14.6663 7.99998 14.6663C11.676 14.6663 14.6666 11.6757 14.6666 7.99967C14.6666 4.3237 11.676 1.33301 7.99998 1.33301ZM7.99998 2.33301C11.1355 2.33301 13.6666 4.86414 13.6666 7.99967C13.6666 11.1352 11.1355 13.6663 7.99998 13.6663C4.86444 13.6663 2.33331 11.1352 2.33331 7.99967C2.33331 4.86414 4.86444 2.33301 7.99998 2.33301ZM7.99998 4.66634C7.82317 4.66634 7.6536 4.73658 7.52858 4.8616C7.40355 4.98663 7.33331 5.1562 7.33331 5.33301C7.33331 5.50982 7.40355 5.67939 7.52858 5.80441C7.6536 5.92944 7.82317 5.99967 7.99998 5.99967C8.17679 5.99967 8.34636 5.92944 8.47138 5.80441C8.59641 5.67939 8.66665 5.50982 8.66665 5.33301C8.66665 5.1562 8.59641 4.98663 8.47138 4.8616C8.34636 4.73658 8.17679 4.66634 7.99998 4.66634ZM7.99217 6.99251C7.85967 6.99458 7.73342 7.04916 7.64113 7.14425C7.54885 7.23934 7.49808 7.36718 7.49998 7.49967V11.1663C7.49904 11.2326 7.51128 11.2984 7.53599 11.3599C7.5607 11.4213 7.59738 11.4773 7.6439 11.5245C7.69042 11.5717 7.74586 11.6091 7.80699 11.6347C7.86812 11.6603 7.93372 11.6735 7.99998 11.6735C8.06624 11.6735 8.13184 11.6603 8.19297 11.6347C8.2541 11.6091 8.30954 11.5717 8.35606 11.5245C8.40258 11.4773 8.43926 11.4213 8.46397 11.3599C8.48868 11.2984 8.50092 11.2326 8.49998 11.1663V7.49967C8.50094 7.43275 8.48846 7.36632 8.46327 7.30431C8.43808 7.2423 8.4007 7.18598 8.35334 7.13869C8.30599 7.09139 8.24962 7.05408 8.18758 7.02897C8.12554 7.00387 8.05909 6.99147 7.99217 6.99251Z"
          fill="#262626"
        />
      </g>
      <defs>
        <clipPath id="clip0_9732_41839">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgOrderSummary;
